module.exports = __webpack_public_path__ + "static/media/tdsEngland.9d3f5ed7.png";